var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.44425 0.666626H3.55591C1.43258 0.666626 0.166748 1.93246 0.166748 4.05579V8.93829C0.166748 11.0675 1.43258 12.3333 3.55591 12.3333H8.43841C10.5617 12.3333 11.8276 11.0675 11.8276 8.94413V4.05579C11.8334 1.93246 10.5676 0.666626 8.44425 0.666626ZM3.94091 5.90496C4.11008 5.73579 4.39008 5.73579 4.55925 5.90496L5.56258 6.90829V3.29746C5.56258 3.05829 5.76091 2.85996 6.00008 2.85996C6.23925 2.85996 6.43758 3.05829 6.43758 3.29746V6.90829L7.44091 5.90496C7.61008 5.73579 7.89008 5.73579 8.05925 5.90496C8.22841 6.07413 8.22841 6.35413 8.05925 6.52329L6.30925 8.27329C6.26841 8.31413 6.22175 8.34329 6.16925 8.36663C6.11675 8.38996 6.05841 8.40163 6.00008 8.40163C5.94175 8.40163 5.88925 8.38996 5.83091 8.36663C5.77841 8.34329 5.73175 8.31413 5.69091 8.27329L3.94091 6.52329C3.77175 6.35413 3.77175 6.07996 3.94091 5.90496ZM9.64008 9.54496C8.46758 9.93579 7.23675 10.1341 6.00008 10.1341C4.76341 10.1341 3.53258 9.93579 2.36008 9.54496C2.13258 9.46913 2.01008 9.21829 2.08591 8.99079C2.16175 8.76329 2.40675 8.63496 2.64008 8.71663C4.81008 9.43996 7.19591 9.43996 9.36591 8.71663C9.59341 8.64079 9.84425 8.76329 9.92008 8.99079C9.99008 9.22413 9.86758 9.46913 9.64008 9.54496Z",
    fill: "#6C6E8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "fee8d01d3b455fa021b6f41b452c4969.svg";
export { ForwardRef as ReactComponent };